import { useForm } from "react-hook-form";
import axios from "axios";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Define the feedback data structure
interface RolePlayFeedbackData {
  rating?: number;
  preparedness_rating?: number;
  subjective_feedback?: string;
  feedback?: string;
  selected_question?: string;
}

export const useSimulationFeedback = () => {
  const form = useForm<RolePlayFeedbackData>();
  const navigate = useNavigate();
  const { sim_id, chat_id } = useParams();

  const [isSubmitting, setIsSubmitting] = useState(false);
  let session_duration = 0;
  let session_end_time = localStorage.getItem("session_end_time");
  let session_start_time = localStorage.getItem("session_start_time");
  if (session_end_time && session_start_time) {
    session_duration = +session_end_time - +session_start_time;
    session_start_time = new Date(+session_start_time).toLocaleString();
    session_end_time = new Date(+session_end_time).toLocaleString();
  }

  const handleSubmit = async (data: RolePlayFeedbackData) => {
    setIsSubmitting(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SIM_BACKEND_HOST}/sim/feedback/save`,
        {
          public_sim_id: localStorage.getItem("sim_id"),
          feedback_text: data.feedback || "",
          feedback_response: {
            preparedness_rating: data.preparedness_rating || "",
            subjective_feedback: data.subjective_feedback || "",
            selected_question: data.selected_question || "",
          },
          session_metrics: {
            session_duration: session_duration,
            session_start_time: session_start_time,
            session_end_time: session_end_time,
            sim_type: localStorage.getItem("sim_type"),
            user_id: localStorage.getItem("user_id"),
          },
        },
        {
          headers: {
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      console.log(response);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
      // Navigate to transcript page after successful feedback submission
      navigate(`/sim/${sim_id}/${chat_id}/transcript`);
    }
  };

  return { form, handleSubmit, isSubmitting };
};
